import React from 'react';
import { handleKeyDown } from '@widergy/utilitygo-forms-web';
import { UTButton } from '@widergy/energy-ui';
import { reduxForm } from 'redux-form';
import { bool, func } from 'prop-types';

import { message } from 'utils/stringUtils';
import UTForm from 'app/components/UTForm';
import { clientNumberField } from 'constants/fields';
import { ACCOUNT_PAYMENT_DOCS } from 'constants/reduxForms';

import styles from './styles.module.scss';

const Form = ({ handleSubmit, submitFailed, invalid }) => (
  <form className={styles.formContainer} onSubmit={handleSubmit} onKeyDown={handleKeyDown(handleSubmit)}>
    <UTForm fields={[clientNumberField]} withoutOrder />
    <div className={styles.buttonContainer}>
      <UTButton disabled={submitFailed && invalid} onPress={handleSubmit}>
        {message('Payments:checkDebt')}
      </UTButton>
    </div>
  </form>
);

Form.propTypes = {
  handleSubmit: func,
  submitFailed: bool,
  invalid: bool
};

export default reduxForm({ form: ACCOUNT_PAYMENT_DOCS })(Form);
